import "animate.css/animate.min.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./assets/css/style.css";
// 引入公共的css
import ElementPlus from "element-plus";

import "element-plus/dist/index.css";
// import "viewerjs/dist/viewer.css";
// import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
import "viewerjs/dist/viewer.css";
createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus)
  .use(VueViewer)
  .mount("#app");
